(function () {
  var scrollToTopBtn = document.querySelector(".back-to-top-btn");
  var rootElement = document.documentElement;

  function handleScroll() {
    // Do something on scroll
    var scrollTotal = rootElement.scrollHeight - rootElement.clientHeight;
    if (rootElement.scrollTop > 100) {
      // Show button
      scrollToTopBtn.classList.add("show-btn");
    } else {
      // Hide button
      scrollToTopBtn.classList.remove("show-btn");
    }
  }

  function scrollToTop() {
    // Scroll to top logic
    rootElement.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
  scrollToTopBtn.addEventListener("click", scrollToTop);
  document.addEventListener("scroll", handleScroll);
})();
